<template>
  <div>
    <page-table ref="pageTable" :init-fetch="true" :loading="tableLoading" :columns="tableColumns"
                :page-total="pageTotal" :table-data="tableData" :show-create-btn="false"
                @fetchData="fetchData">
      <template slot="searchForm">
        <FormItem class="margin-bottom-0">
          <Input v-model="params.keywords" placeholder="用户名/电话/姓名/活动标题" style="width: 260px"></Input>
        </FormItem>
        <FormItem class="margin-bottom-0">
          <DatePicker v-model="params.register_date" type="datetimerange" placement="bottom-end" placeholder="报名时间"
                      style="width: 330px"></DatePicker>
        </FormItem>
        <FormItem class="margin-bottom-0">
          <Select v-model="params.status" clearable placeholder="" style="width:120px">
            <Option v-for="item in registerSelectList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem class="margin-bottom-0">
          <Select v-model="params.type" clearable placeholder="报名类型" style="width:120px">
            <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem class="margin-bottom-0">
          <Button
            type="info"
            ghost
            @click="exportData"
            :loading="tableLoading"
          >导出模板</Button>
        </FormItem>
      </template>

      <template slot="avatar" slot-scope="{ row }">
        <Avatar :src="row.avatar"></Avatar>
      </template>
      <template slot="status" slot-scope="{ row }">
        <Tag checkable color="primary" v-if="row.status === 1">报名失败</Tag>
        <Tag checkable color="success" v-if="row.status === 2">报名成功</Tag>
        <Tag checkable color="warning" v-if="row.status === 3">已失效</Tag>
        <Tag checkable color="error" v-if="row.status === 0">正在报名</Tag>
      </template>
      <template slot="type" slot-scope="{ row }">
        <Tag checkable color="primary" v-if="row.type === 10">参观登记</Tag>
        <Tag checkable color="success" v-if="row.type === 11">参展登记</Tag>
        <Tag checkable color="warning" v-if="row.type === 20">参会登记</Tag>
        <Tag checkable color="error" v-if="row.type === 21">广告演讲</Tag>
      </template>
      <template slot="address" slot-scope="{ row }">
        <span>{{row.province + row.city + row.area + row.company_address}}</span>
      </template>
      <template slot="invoice_info" slot-scope="{ row }">
        <Poptip v-if="row.invoice_info" placement="right" width="400" :transfer="true">
          <Button>查看发票</Button>
          <div class="api" slot="content">
            <table>
              <tbody>
              <tr>
                <td>抬头名称:{{row.invoice_info.title}}</td>
              </tr>
              <tr>
                <td>抬头税号:{{row.invoice_info.taxNumber}}</td>
              </tr>
              <tr>
                <td>单位地址:{{row.invoice_info.companyAddress}}</td>
              </tr>
              <tr>
                <td>电话号码:{{row.invoice_info.telephone}}</td>
              </tr>
              <tr>
                <td>银行名称:{{row.invoice_info.bankName}}</td>
              </tr>
              <tr>
                <td>银行账号:{{row.invoice_info.bankAccount}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </Poptip>
      </template>
    </page-table>
    <Drawer v-model="detailDrawer.show" :title="detailDrawer.title"  :mask-closable="false" width="1000">
      <detail :id="detailDrawer.id"></detail>
    </Drawer>
  </div>
</template>

<script>
import pageTable from '../../components/pageTable/index'
import Detail from '../member/components/detail'
import { exportRegisterRecord, getActivityRegisterRecord } from '../../api/activity'

export default {
  name: 'register-record',
  components: { Detail, pageTable },
  data () {
    return {
      params: {
        keywords: '',
        register_date: [],
        status: 2
      },
      tableLoading: false,
      tableData: [],
      pageTotal: 0,
      detailDrawer: {
        show: false,
        loading: false,
        title: '',
        id: 0
      },
      registerSelectList: [
        { value: 1, label: '报名失败' },
        { value: 2, label: '报名成功' },
        { value: 3, label: '已失效' },
        { value: 0, label: '正在报名' }
      ],
      typeList: [
        { value: 10, label: '参观登记' },
        { value: 11, label: '参展登记' },
        { value: 20, label: '参会登记' },
        { value: 21, label: '广告演讲' }
      ]
    }
  },
  computed: {
    tableColumns () {
      return [
        { title: '头像', key: 'avatar', slot: 'avatar', width: 60 },
        { title: '用户名', key: 'nickname', tooltip: true },
        { title: '姓名', key: 'realname', align: 'center', width: 80, tooltip: true },
        { title: '身份证号', key: 'id_card', align: 'center', width: 160, tooltip: true },
        { title: '电话', key: 'mobile', align: 'center', width: 110, tooltip: true },
        { title: '活动标题', key: 'title', tooltip: true },
        { title: '邮箱', key: 'email', tooltip: true, width: 180 },
        { title: '职位', key: 'position', tooltip: true, width: 90 },
        { title: '公司名称', key: 'company_name', align: 'center', width: 150, tooltip: true },
        { title: '主营产品', key: 'company_product', align: 'center', tooltip: true },
        { title: '公司地址', key: 'address', align: 'center', slot: 'address', tooltip: true },
        { title: '报名状态', key: 'status', align: 'center', slot: 'status' },
        { title: '活动类型', key: 'type', align: 'center', slot: 'type' },
        { title: '发票信息', key: 'invoice_info', align: 'center', slot: 'invoice_info' },
        { title: '报名时间', key: 'create_time', align: 'center' }
      ]
    }
  },
  methods: {
    fetchData (page) {
      this.tableLoading = true
      const params = { ...this.params, ...page }
      getActivityRegisterRecord(params).then(({ data }) => {
        this.tableData = data.data
        this.pageTotal = data.total
      }).finally(() => {
        this.tableLoading = false
      })
    },
    btnHandler (e, row) {
      this[e](row)
    },
    exportData () {
      const param = { ...this.params }
      this.tableLoading = true
      exportRegisterRecord(param).then(res => {
        const blobData = res.data
        const blob = new Blob([blobData], { type: blobData.type })
        const downloadElement = document.createElement('a')
        const href = window.URL.createObjectURL(blob)// 创建下载的链接
        downloadElement.href = href
        const fileName = '报名记录'
        downloadElement.download = decodeURI(fileName) // 下载后文件名
        document.body.appendChild(downloadElement)
        downloadElement.click() // 点击下载
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放blob对象
      }).finally(res => {
        this.tableLoading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
